const ImageMimeType = {
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  HDR: 'image/vnd.radiance',
  KTX2: 'image/ktx2',
  GLTEXTURE: 'image/texture',
}

export { ImageMimeType }
